var t = /* @__PURE__ */ ((r) => (r.SOLID = "solid", r.OUTLINE = "outline", r))(t || {}), n = /* @__PURE__ */ ((r) => (r.FIT_CONTENT = "fit-content", r.FULL_WIDTH = "full-width", r))(n || {});
export {
  t as TagStyle,
  n as TagWidth
};
//# sourceMappingURL=enums.js.map
